export interface SpinTogetherAccessOptions {
    configuredTelegramUserIds: string | null | undefined;
    environment: string | null | undefined;
    telegramUserId: string | number | bigint | null | undefined;
}

export function spinTogetherEnabledForTelegramUser({
    configuredTelegramUserIds,
    environment,
    telegramUserId,
}: SpinTogetherAccessOptions): boolean {
    const configuredUsers = configuredTelegramUserIds?.trim();
    if (!configuredUsers) return environment !== "production";

    const allowedUsers = new Set(
        configuredUsers
            .split(",")
            .map((value) => value.trim())
            .filter(Boolean),
    );
    if (allowedUsers.has("*")) return true;
    if (telegramUserId === null || telegramUserId === undefined) return false;
    return allowedUsers.has(String(telegramUserId));
}
